import { useEffect, useState } from "react";
import { GridWrap } from "../ui/wrappers/GridWrap/GridWrap";
import { OrderStatusSelector } from "../view/OrderStatusSelector/OrderStatusSelector";
import { useGetOrdersMutation } from "../../store/orders/ordersApi";
import LoadBlock from "../view/LoadBlock/LoadBlock";
import { TextError } from "../ui/errors/TextError/TextError";
import { OrderItem } from "../view/OrderItem/OrderItem";

export const Orders = () => {
  const [statusSelect, setStatusSelect] = useState("PAID");
  const [getOrders, { data: ordersData, isLoading: orderLoad, error }] =
    useGetOrdersMutation();

  const handleStatusSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setStatusSelect(value);
  };

  const handleReload = () => {
    if (statusSelect) getOrders(statusSelect);
  };

  useEffect(() => {
    if (statusSelect) getOrders(statusSelect);
  }, [statusSelect, getOrders]);

  return (
    <section>
      <OrderStatusSelector value={statusSelect} action={handleStatusSelect} />
      {orderLoad ? (
        <LoadBlock />
      ) : error ? (
        <TextError text="Ошибка при загрузке" />
      ) : (
        <GridWrap column={1}>
          {ordersData && ordersData.length > 0
            ? ordersData.map((item) => (
                <OrderItem key={item.uuid} item={item} reload={handleReload} />
              ))
            : null}
        </GridWrap>
      )}
    </section>
  );
};
